/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useState,useEffect,useRef } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import Header from '../../components/includes/Header';
import HeaderTitle from '../../components/includes/HeaderTitle';

import { isObjEmpty,ChangeMobileFormat,ChangeMobileNumber } from '../../components/common/Common';

import "../../css/style.css";

//아이디 찾기
const FindID = () => {
  const navigate = useNavigate();

  const refName = useRef();
  const refMobile = useRef();
  const refFind = useRef();

  const [varMember,setMember] = useState({});
  //입력정보저장객체
  useEffect(() => {
    const newMember = {mem_mode:1, mem_name:"", mem_mobile:""};
    setMember(newMember);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === 'mem_mobile') {
      const svalue = ChangeMobileNumber(value);
      setMember({...varMember,[name]:svalue});
    } else {
      setMember({...varMember,[name]:value});
    }
  }

  //키보드
  const onKeyPressHandler = (e,ino) => {
    if (e.key === 'Enter') {
      if(ino === 0) {
        refMobile.current.focus();
      } else {
        refFind.current.click();
      }
    }
  }

  //아이디 찾기 실행
  const onFindIDHandler = async (e) => {
    if (varMember.mem_mobile === "") {
      alert('휴대폰 번호를 먼저 입력하세요'); return false;  
    } else if (varMember.mem_name === "" ) {
      alert('이름을 먼저 입력하세요'); return false;      
    }
    const sendData = {dataInfos:varMember}
    await axios.post(`${process.env.REACT_APP_HOST}/_find_id`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        const mem_id = datas.mem_id;
        localStorage.setItem("foundID", mem_id);
        navigate('/FoundIDOK');
      } else {
        alert(datas.message);
      }
    });
  }

  return isObjEmpty(varMember)?null:(
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'아이디 찾기'}/>
        <div className="vh-content-body">
          <div className="form-guide">
            <p>가입 시 등록했던 정보를 입력하세요.</p>
          </div>
          <div className="form-group ms25 mb25">
            <label className="form-label">이름</label>
            <div className="field-group">
              <input type="text" name="mem_name" ref={refName} value={varMember.mem_name} placeholder="이름을 입력하세요." className="form-control" onKeyPress={e=>onKeyPressHandler(e,0)} onChange={onChangeInputHandler}/>
            </div>
            <div className="invalid-feedback"></div>
          </div>
          <div className="form-group ms25 mb25">
            <label className="form-label">휴대폰 번호</label>
            <div className="field-group">
              <input type="text" name="mem_mobile" ref={refMobile} value={ChangeMobileFormat(varMember.mem_mobile)} placeholder="휴대폰 번호를 입력하세요." className="form-control" onKeyPress={e=>onKeyPressHandler(e,1)} onChange={onChangeInputHandler} />
            </div>
            <div className="invalid-feedback"></div>
          </div>
          <div className="form-contoller flex-horizontal mt-auto mb50 ms25">
            <Link to="/Login" className="form-contoller-btn btn-white">취소</Link>
            <button ref={refFind} className="form-contoller-btn" onClick={e=>onFindIDHandler(e)}>확인</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FindID;